import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useReserhubAccount } from '@/context/ReserhubAccount';
import useWhitelabelEnvs from 'hooks/whitelabel/useWhitelabelEnvs';
import { getCdsMenuProfile } from 'services/commerce-api/cdsMenuProfile';
import gift from 'images/brands-unique/cds/black-gift.webp';
import tierIcons from '../CdsPointsCheckout/cdsTierIcons';

export default function CdsPointsPaymentSummary({ pointsAmount, accountId, token, variant }) {
  const earned = variant === 'earned';
  const { user } = useReserhubAccount();
  const env = useWhitelabelEnvs();
  const [profile, setProfile] = useState(null);
  const scope = JSON.stringify([env.reserhub?.api?.baseUrl, user?.id, user?.sessionToken]);
  const ownsPurchase = accountId != null && String(accountId) === String(user?.id);
  const canLoad = ownsPurchase && Boolean(user?.sessionToken);

  useEffect(() => {
    if (!canLoad) return undefined;
    let cancelled = false;
    getCdsMenuProfile(scope, token)
      .then((result) => {
        if (!cancelled && result)
          setProfile({ scope, category: result.category ?? result.wallet?.category });
      })
      .catch(() => {
        if (!cancelled) setProfile(null);
      });
    return () => {
      cancelled = true;
    };
  }, [canLoad, scope, token]);

  const category = canLoad && profile?.scope === scope ? profile.category : null;
  const tier = typeof category === 'string' ? category.trim().toLowerCase() : '';
  const tierIcon = tierIcons[tier];

  if (earned && !canLoad) return null;

  return (
    <>
      {earned && <h2 className="cds-points-rewards-title">Recompensas</h2>}
      <section
        className={`cds-points-payment-summary${
          earned ? ' cds-points-payment-summary--earned' : ''
        }`}
        aria-label={earned ? 'Puntos obtenidos' : 'Puntos canjeados'}
      >
        <h2>¡Aventura desbloqueada con tus Puntos!</h2>
        <div className="cds-points-payment-summary__body">
          {tierIcon && (
            <img
              className="cds-points-payment-summary__tier"
              src={tierIcon}
              alt={`Categoría ${tier}`}
            />
          )}
          <strong>
            {earned ? '+' : '-'} {pointsAmount} CASH CDS
          </strong>
          <span>{earned ? 'Obtenidos' : 'Canjeados'}</span>
        </div>
        <img className="cds-points-payment-summary__gift" src={gift} alt="" aria-hidden="true" />
      </section>
    </>
  );
}

CdsPointsPaymentSummary.propTypes = {
  pointsAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  accountId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  token: PropTypes.string,
  variant: PropTypes.oneOf(['redeemed', 'earned']),
};
CdsPointsPaymentSummary.defaultProps = { accountId: null, token: null, variant: 'redeemed' };
